import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "components/Sidebar/Sidebar.js";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import HeaderStats from "components/Headers/HeaderStats.js";
import FooterAdmin from "components/Footers/FooterAdmin.js";
import ChatWidget from "components/Chat/ChatWidget.js";

export default function Admin() {
  return (
    <div className="flex min-h-screen" style={{ backgroundColor: "var(--color-bg)" }}>
      <Sidebar />
      <ChatWidget />

      {/* Main content — offset by sidebar width on md+, and by mobile topbar height on mobile */}
      <div className="flex-1 flex flex-col min-w-0 md:ml-64 pt-14 md:pt-0">
        <AdminNavbar />
        <HeaderStats />

        {/* Page content — on md+ the -mt-16 pulls content up over the gradient banner */}
        <main className="flex-1 px-3 md:px-8 py-4 md:py-6 md:-mt-16 relative">
          <Outlet />
        </main>

        <FooterAdmin />
      </div>
    </div>
  );
}

